module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"activeFilters":"{count} Filter aktiv | {count} Filter aktiv","resetAll":"Zurücksetzen","topicFilter":"Thema: {topic}","multipleTopics":"{count} Themen"},"en":{"activeFilters":"{count} filter active | {count} filters active","resetAll":"Reset","topicFilter":"Topic: {topic}","multipleTopics":"{count} topics"}}')
  delete Component.options._Ctor
}
